/*
 * @Author: 刘枫 
 * @Date: 2021-04-26 10:58:12 
 * @Description: 水务动态
 * @Last Modified by: liufeng
 * @Last Modified time: 2021-04-29 21:30:22
 */

<template>
  <div class="must-know">
    <van-nav-bar left-text="返回" :title="title" @click-left="onClickLeft" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="comm-seperator"></div>
        <div class="must-know-list">
          <van-list v-model="loading" :finished="finished" :finished-text="'没有更多了'" @load="onLoad" :immediate-check="false">
            <div v-for="(article, i) in articleList" :key="i">
              <must-know-item :article="article" :title="title"></must-know-item>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import MustKnowItem from './companyNews'
export default {
  components: {
    MustKnowItem
  },
  data() {
    return {
      active: 0,
      tabs: [
        {
          title: '公司新闻'
        },
        {
          title: '工作动态'
        },
        {
          title: '重点工作'
        },
        {
          title: '重点政府工作'
        }
      ],
      typeCode: 101,
      articleList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      title: ''
    }
  },
  mounted() {
    this.onChange(this.active)
  },
  methods: {
    onLoad() {
      console.log(this.page)
      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.articleList = []
      //     this.refreshing = false
      //     this.page = 1
      //   } else {
      //     this.page++
      //   }
      this.page++
      this.getArticleData()
      // }, 1000)
    },
    onClickLeft() {
      window.location.href = 'http://www.lnldsw.com:9991'
    },
    onChange(index) {
      if (index === 0) {
        this.typeCode = 106
      } else if (index === 1) {
        this.typeCode = 107
      } else if (index === 2) {
        this.typeCode = 108
      } else {
        this.typeCode = 109
      }
      this.title = this.tabs[index].title
      this.articleList = []
      this.page = 1
      this.getArticleData()
    },
    getArticleData() {
      let params = {
        "typecode": this.typeCode,
        "pagesize": 20,
        "pageindex": this.page
      }
      this.loading = true
      this.$http.post(this.$api.getArticles, params).then(res => {
        this.loading = false
        if (res.data && res.data.length > 0) {
          this.articleList = this.articleList.concat(res.data)
          if (this.articleList.length >= parseInt(res.totalcount)) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.must-know {
  .sales-net-list {
    padding: 0 16px;
  }
}
</style>